import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = ["for"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "slider" }, null, -1)
const _hoisted_4 = [
  _hoisted_3
]


import { restaurant } from '@/global/state/GlobalState';


export default /*#__PURE__*/_defineComponent({
  __name: 'MySwitch',
  props: {
    id: {},
    setChecked: { type: Function }
  },
  setup(__props: any) {

_useCssVars(_ctx => ({
  "35fb5936": (_unref(restaurant)?.restaurant_design_custom?.primary_color)
}))



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("input", {
      class: "hidden chk",
      type: "checkbox",
      id: _ctx.id,
      onInput: _cache[0] || (_cache[0] = (e) => {_ctx.setChecked(e.target.checked)})
    }, null, 40, _hoisted_1),
    _createElementVNode("label", {
      for: _ctx.id,
      class: "switch"
    }, _hoisted_4, 8, _hoisted_2)
  ]))
}
}

})